import moment from 'moment';

export default function(value, now)
{
    now = Date.now();
    return moment.duration(value - now).humanize(true);
}